export const ButtonNamesGA = {
  SaveChanges: 'Save Changes',
  AddToPack: 'Add to Pack',
  AddItemsToPack: 'Add Items to Pack',
  DownloadPrototypeReport: 'Download Prototype Report',
  ExportPackView: 'Export Pack View',
  ExportPack: 'Export Pack',
  CreatePack: 'Create Pack',
  CreateRevisionFromThisPack: 'Create Revision from this Pack',
  CreateCopyFromThisPack: 'Create Copy from this Pack',
  CreateSisterLocalFromThisPack: "Create 'Sister'/'Local' from this Pack",
  CreatePackFromScratch: 'Create Pack from Scratch',
  CreatePackFromExistingPack: 'Create Pack from Existing Pack',
  OpenPack: 'Open Pack',
  RouteQuote: 'Route Quote',
  RespondToRequest: 'Respond to Request',
  TakeOwnership: 'Take Ownership',
  TransferOwnership: 'Transfer Ownership',
  ArchivePack: 'Archive Pack',
  UnarchivePack: 'Unarchive Pack',
  PackProperties: 'Pack Properties',
  GenerateDocument: 'Generate Document',
  MakeContract: 'Make Contract',
  MakePrototype: 'Make Prototype',
  AssignAccount: 'Assign Account',
  SendToIrisStaging: 'Send to Iris Staging',
  DeletePack: 'Delete Pack',
  ClearFromInbox: 'Clear From Inbox',
  ClearPackYes: 'Clear Pack Yes',
  ClearPackNo: 'Clear Pack No',
  DeletePackYes: 'Delete Pack Yes',
  DeletePackNo: 'Delete Pack No',
  ChangeAccount: 'Change Account',
  Assign: 'Assign',
  Change: 'Change',
  ViewProductPage: 'View Product page',
  ReplacePart: 'Replace Part',
  ChangePartLocation: 'Change Part Location',
  WhereUsed: 'Where Used',
  DeletePart: 'Delete Part',
  Compare: 'Compare',
  ZoomIn: 'Zoom In',
  ZoomOut: 'Zoom Out',
  CollapseExpandPricingPanel: 'Collapse/Expand Pricing Panel',
  CurrencySettings: 'Currency Settings',
  PackNotifications: 'Pack Notifications',
  MyProfile: 'My Profile',
  RestoreDefaults: 'Restore Defaults',
  Logout: 'Logout',
  PresentationMode: 'Presentation Mode',
  ViewOtherUsersInbox: "View Other User's Inbox",
  Clear: 'Clear',
  Select: 'Select',
  Close: 'Close',
  AddToQuote: 'Add to Quote +',
  CopyPaste: 'Copy-Paste',
  EnlargeImage: 'Enlarge Image',
  UserDetails: 'User Details',
  Save: 'Save',
  Cancel: 'Cancel',
  CancelYes: 'Cancel Yes',
  CancelNo: 'Cancel No',
  OpenTemplate: 'Open Template',
  TemplateProperties: 'Template Properties',
  CreateTemplate: 'Create Template',
  SelectAll: 'Select All',
  DeselectAll: 'Deselect All',
  AddCategory: 'Add Category',
  Update: 'Update',
  DeleteCategory: 'Delete Category',
  Search: 'Search',
  GlobalSearch: 'Global Search',
  ReturnToPreviousScreen: 'Return to previous Screen',
  CreateQuote: 'Create Quote',
  RecallPack: 'Recall Pack',
  Send: 'Send',
  AddItemToQuote: 'Add Item to Quote',
  Replace: 'Replace',
  OpenInCatalog: 'Open in Catalog',
  BackToPreviousPage: 'Back to Previous Page',
  RemoveFromComparison: 'Remove from Comparison',
  AccountProperties: 'Account Properties',
  TurnOnTheOptimizer: 'Turn on the Optimizer',
  TurnOn3D: 'Turn on 3D',
  AddRecommdedItem: 'Add Recommended Item',
  CollapseExpandRecommendedCategory: 'Collapse/Expand Recommended Category',
  CollapseExpandAll: 'Collapse/Expand All',
  FullScreen: 'Full Screen',
  ViewECO: 'View ECO',
  ShowResults: 'Show Results',
  EditECO: 'Edit ECO',
  PreviewECO: 'Preview ECO',
  CreateECO: 'Create ECO',
  ExecuteECO: 'Execute ECO',
  ExecuteECOYes: 'Execute ECO Yes',
  ExecuteECONo: 'Execute ECO No',
  AddPair: 'Add Pair',
  DeleteECO: 'Delete ECO',
  DeleteECOYes: 'Delete ECO Yes',
  DeleteECONo: 'Delete ECO No',
  DeletePair: 'Delete Pair',
  ExportECO: 'Export ECO',
  ShowInactive: 'Show Inactive',
  EditTemplate: 'Edit Template',
  ExportTemplate: 'Export Template',
  DeleteDocumentTemplate: 'Delete Document Template',
  DeleteDocumentTemplateYes: 'Delete Document Template Yes',
  DeleteDocumentTemplateNo: 'Delete Document Template No',
  ChooseFile: 'Choose File',
  InsertToken: 'Insert Token',
  BulkPriceChange: 'Bulk Price Change',
  Run: 'Run',
  ImportGuidelines: 'Import Guidelines',
  ExportGuidelines: 'Export Guidelines',
  Filter: 'Filter',
  ImportPartCost: 'Import Part Cost',
  ExportPartCost: 'Export Part Cost',
  PricingProperties: 'Pricing Properties',
  Download: 'Download',
  NotificationBell: 'Notification Bell',
  Undefined: '',
  SaveToSalesforce: 'Save to Salesforce',
  ImportContracts: 'Import Contracts',
  Submit: 'Submit',
  ExportPreview: 'Export Preview',
  ReportPreview: 'Report Preview',
  SubmitPreview: 'Submit Preview',
  ExportResult: 'Export Result',
  RefreshResults: 'Refresh Results',
  InfoLocationInPak: 'Info Location In Pak',
  InfoEditPrice: 'Info Edit Price',
  InfoPartPair: 'Info Part Pair',
} as const;
